/**
 * Временные флаги: скрыть недоделанные разделы до релиза.
 * Включить нужный флаг, когда раздел готов к показу клубам.
 */
export const PRODUCT_FLAGS = {
  /** Старый мастер «Первичная настройка» на главной (AdminOnboarding). */
  onboarding: false,
  /** Новый «Быстрый старт» с подсказками на живых экранах (Activation + Tour). */
  quickStart: true,
  /** База знаний /manage/app/help — пока скрыта. */
  help: false,
  /** Новый светлый лендинг `/` — выключен, на главной тёмно-фиолетовый как раньше. */
  homeLandingV2: false,
  analytics: false,
  modules: false,
  salesFunnel: true,
};

/**
 * Автозапуск Quick Start только для клубов с этой даты (МСК).
 * Старые клубы могут пройти тур вручную («Быстрый старт» в меню).
 */
export const QUICK_START_SINCE = "2026-09-24T00:00:00+03:00";

export function isOnboardingEnabled() {
  return PRODUCT_FLAGS.onboarding;
}

/** Фича включена: провайдеры, кнопка «пройти заново» — для всех клубов. */
export function isQuickStartFeatureOn() {
  return PRODUCT_FLAGS.quickStart;
}

/** Клуб новый → авто-приветствие и тур без ручного запуска. */
export function isQuickStartEligibleClub(tenant) {
  const raw = tenant?.createdAt || tenant?.created_at;
  if (!raw) return false;
  const created = new Date(raw).getTime();
  if (Number.isNaN(created)) return false;
  return created >= new Date(QUICK_START_SINCE).getTime();
}

/**
 * Автозапуск тура для клуба (только новые регистрации).
 * Ручной перезапуск доступен всем при isQuickStartFeatureOn().
 */
export function isQuickStartAutoStart(tenant) {
  return isQuickStartFeatureOn() && isQuickStartEligibleClub(tenant);
}

/** Фича Quick Start для UI/провайдеров (не cutoff по дате). */
export function isQuickStartEnabled(_tenant) {
  return isQuickStartFeatureOn();
}

export function isHelpEnabled() {
  return PRODUCT_FLAGS.help;
}

export function isHomeLandingV2Enabled() {
  return PRODUCT_FLAGS.homeLandingV2;
}

export function isAnalyticsEnabled() {
  return PRODUCT_FLAGS.analytics;
}

export function isModulesEnabled() {
  return PRODUCT_FLAGS.modules;
}

export function isSalesFunnelEnabled() {
  return PRODUCT_FLAGS.salesFunnel;
}
